import type { NikolaMemoryResponse, UserSettingsPatch, UserSettingsResponse } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";

export const fetchUserSettings = (signal: AbortSignal): Promise<UserSettingsResponse> =>
  apiClient("/user-settings/me", { signal });

export const migrateLegacyUserSettings = (
  settings: UserSettingsPatch,
  signal?: AbortSignal,
): Promise<UserSettingsResponse> =>
  apiClient("/user-settings/me/legacy-migration", {
    method: "POST",
    body: JSON.stringify(settings),
    ...(signal ? { signal } : {}),
  });

export const patchUserSettings = (settings: UserSettingsPatch, signal?: AbortSignal): Promise<UserSettingsResponse> =>
  apiClient("/user-settings/me", {
    method: "PATCH",
    body: JSON.stringify(settings),
    ...(signal ? { signal } : {}),
  });

export const deleteNikolaMemory = (): Promise<void> => apiClient<void>("/coach/memory", { method: "DELETE" });
export const fetchNikolaMemory = (): Promise<NikolaMemoryResponse> => apiClient("/coach/memory");
export const deleteNikolaMemoryItem = (memoryId: string): Promise<void> =>
  apiClient<void>(`/coach/memory/${encodeURIComponent(memoryId)}`, { method: "DELETE" });

interface NikolaConversationExport {
  filename: string;
  mediaType: "application/json";
  content: string;
}

export const deleteNikolaConversationHistory = (): Promise<void> =>
  apiClient<void>("/coach/conversations", { method: "DELETE" });

export const fetchNikolaConversationExport = (): Promise<NikolaConversationExport> =>
  apiClient<NikolaConversationExport>("/coach/conversations/export");

export const downloadNikolaConversationHistory = async (): Promise<void> => {
  const file = await fetchNikolaConversationExport();
  const url = URL.createObjectURL(new Blob([file.content], { type: file.mediaType }));
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = file.filename;
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
  }
};
